@if (displayLabel()) {
<div class="flex items-center mb-1 whitespace-nowrap">
  @if (emojiLabel) {
  <div class="mr-2 text-gray-400 flex items-center justify-center w-5 h-5 flex-shrink-0">
    {{emojiLabel}}
  </div>
  }
  <div class="flex items-center">
    <mat-label class="text-sm font-medium text-gray-700">{{label}}</mat-label>
    @if (required()) {
    <span class="text-red-500 ml-1 font-bold">*</span>
    }
  </div>
</div>
}